<template>
  <div>
    <v-text-field
      v-model="searchLaboratory"
      append-icon="mdi-magnify"
      label="Buscar"
      single-line
      hide-details
      class="mx-5 mb-3"
    ></v-text-field>
    <v-data-table
      :headers="headersLaboratory"
      :items="listLaboratoryStudies"
      :search="searchLaboratory"
      :items-per-page="10"
      :footer-props="{
        'items-per-page-text': 'Elementos por página',
        'items-per-page-all-text': 'Todo',
      }"
      no-results-text="Sin resultados coincidentes con la búsqueda"
      loading-text="Cargando..."
      no-data-text="Sin resultados disponibles"
      class="mx-5"
      dense
      fixed-header
      height="auto"
    >
      <template v-slot:[`item.count`]="{ index }">
        {{ index + 1 }}
      </template>
      <template v-slot:[`item.status`]="{ item }">
        <span>{{ item.studyStatus }}</span>
      </template>

      <template v-slot:[`item.actions`]="{ item }">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              @click="downloadInterpretationLaboratory(item)"
              :disabled="item.status != 13"
            >
              <v-icon color="red" dark v-bind="attrs" v-on="on">
                mdi-file-pdf-box
              </v-icon>
            </v-btn>
          </template>
          <span>Descargar estudio PDF</span>
        </v-tooltip>
      </template>
    </v-data-table>
  </div>
</template>

<script>
export default {
  props: {
    downloadInterpretationLaboratory: Function,
    listLaboratoryStudies: Array,
  },
  data() {
    return {
      searchLaboratory: "",
      headersLaboratory: [
        { text: "#", value: "count" },
        { text: "Id Estudio", value: "idStudy" },
        { text: "Fecha de solicitud", value: "registrationDate" },
        { text: "Modalidad", value: "modality" },
        { text: "Estudio", value: "studyType" },
        { text: "Químico validador", value: "interpreter" },
        { text: "Fecha de validación", value: "interpretationDate" },
        { text: "Acciones", value: "actions", sortable: false },
      ],
    };
  },
};
</script>

<style></style>
